import { AxiosResponse } from "axios";
import { withPath } from "library/api/api";
import { camelToSnakeCase, convertObjectKeysCase } from "library/transforms";
import { components } from "../card-management-service.generated";
import { getHref, putHref } from "../httpMethods";
import { GetPaymentNotificationPreferencesResponse } from "./types.generated";

type PutPaymentNotificationPreferencesPayload = {
  token: string;
  payload: Partial<GetPaymentNotificationPreferencesResponse>;
  state: GetPaymentNotificationPreferencesResponse;
};

export const getPaymentNotificationPreferences = (
  token: string,
): Promise<AxiosResponse<GetPaymentNotificationPreferencesResponse>> =>
  getHref<GetPaymentNotificationPreferencesResponse>(
    withPath(`v1/card-management/${token}/payment-notification-preferences`),
  );

export const putPaymentNotificationPreferences = ({
  token,
  payload,
  state,
}: PutPaymentNotificationPreferencesPayload): Promise<
  AxiosResponse<
    components["schemas"]["PutPaymentNotificationPreferencesResponse"]
  >
> => {
  const newPayload = {
    emailBeforePaymentDue: state?.emailBeforePaymentDue ?? false,
    emailAfterPaymentReceived: state?.emailAfterPaymentReceived ?? false,
    ...payload,
  };
  const reqPayload = convertObjectKeysCase(newPayload, camelToSnakeCase);

  return putHref(
    withPath(`v1/card-management/${token}/payment-notification-preferences`),
    reqPayload,
  );
};
